$(window).scroll(function () {
  if ($(this).scrollTop() > 10) {
    $(".hdr_sec").addClass("fixed");
  } else {
    $(".hdr_sec").removeClass("fixed");
  }
});
  
// the selector will match all input controls of type :checkbox
$("input:checkbox").on("click", function () {
  var $box = $(this);
  if ($box.is(":checked")) {
    var group = "input:checkbox[name='" + $box.attr("name") + "']";
    $(group).prop("checked", false);
    $box.prop("checked", true);
  } else {
    $box.prop("checked", false);
  }
});

$(".prdct_dtl_sldr").slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: false,
  arrows: false,
  fade: true,
  speed: 100,
  asNavFor: ".prdct_dtl_sldr_nav",
  responsive: [
    {
      breakpoint: 576,
      settings: {
        adaptiveHeight: true,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
  ],
});

$(".prdct_dtl_sldr_nav").slick({
  slidesToShow: 4,
  speed: 400,
  slidesToScroll: 1,
  asNavFor: ".prdct_dtl_sldr",
  infinite: false,
  focusOnSelect: true,
  arrows: true,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      },
    },
  ],
});

$(document).ready(function () {
  $(".minus").click(function () {
    var $input = $(this).parent().find("input");
    var count = parseInt($input.val()) - 1;
    count = count < 1 ? 1 : count;
    $input.val(count);
    $input.change();
    return false;
  });
  $(".plus").click(function () {
    var $input = $(this).parent().find("input");
    $input.val(parseInt($input.val()) + 1);
    $input.change();
    return false;
  });
});

// product_slider
$(".product_slider_wrap").slick({
  dots: false,
  arrows: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      },
    },
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ],
});

// Fancybox Config
$('[data-fancybox="gallery"]').fancybox({
  buttons: [
    // "slideShow",
    "zoom",
    "close",
  ],
  loop: false,
  protect: true,
});

// AOS
AOS.init({
  duration: 1400,
  // delay: 100,
});
AOS.init({
  disable: function () {
    var maxWidth = 991;
    return window.innerWidth < maxWidth;
  },
});
